export default function Introduction() {
  const specs = [{
    label: "Քաշ",
    value: "16.416 կգ"
  }, {
    label: "Սպեկտրալ Լուծաչափ",
    value: "2.5մ (RGB) and 3.0մ (NIR)"
  }, {
    label: "Չափեր",
    value: "226.3*226.3*454մմ³(16U)"
  }, {
    label: "Սպեկտրալ Տիրույթներ",
    value: "Մուլտիսպեկտրալ RGBN"
  }, {
    label: "Ուղեծիր",
    value: "Արևասինխրոն\xA0"
  }, {
    label: "Բիթային Խորություն",
    value: "12\xA0 բիթ"
  }];
  return <section id="introduction" className="bg-zinc-950 text-zinc-50 py-16 md:py-24 light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-16 font-default tracking-wide">Արմսաթ 1</h2>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 mb-16 lg:mb-24 items-center">
          <div className="relative w-full aspect-square md:aspect-[4/3] lg:aspect-square rounded-lg overflow-hidden bg-zinc-900">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/armsat_satellite_render.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/armsat_satellite_render.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/armsat_satellite_render.png-wvc-sizes" alt="ARMSAT 1 Satellite" className="object-contain w-full h-full p-8" loading="lazy" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/a5eaf9ee-7cd0-4925-b348-93b98f9cfcc1.png" src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/a5eaf9ee-7cd0-4925-b348-93b98f9cfcc1-1.png" />
          </div>
          <div className="space-y-6 text-zinc-300 text-sm md:text-base leading-relaxed text-justify lg:text-left">
            <p className="!text-xl">2022 թվականի մայիսի 25-ին Կանավերալ հրվանդանի տիեզերական ուժերի բազայից SpaceX Falcon 9 հրթիռով ուղեծիր դուրս բերված&nbsp; Արմսաթ 1-ը Հայաստանի առաջին&nbsp; Երկրի դիտարկման արբանյակն է:</p>
            <p className="!text-xl">Ժամանակակից 16U CubeSat հարթակի վրա կառուցված Արմսաթ 1-ը համալրված է առաջադեմ օպտիկական ակնապակիով՝ ապահովելով չորս սպեկտրալ գոտիներով (RGB և NIR) պատկերներ՝ 2.5-3 մետր լուծաչափով:&nbsp;</p>
            <p className="!text-xl">
              Հարթակը մշակվել է իսպանական NanoAvionics ընկերության կողմից, իսկ
              օպտիկական բեռը ստեղծվել է իսպանական Satlantis ընկերության կողմից:
            </p>
            
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-stretch">
          <div className="relative w-full aspect-video md:aspect-[4/3] lg:aspect-auto lg:h-full rounded-lg overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/armsat_rocket_launch.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/armsat_rocket_launch.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/armsat_rocket_launch.png-wvc-sizes" alt="ARMSAT 1 Rocket Launch" className="object-cover w-full !h-[420px]" loading="lazy" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/2cbcad0d-1852-405d-89b1-8e186e9afda4.png" src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/2cbcad0d-1852-405d-89b1-8e186e9afda4-1.png" />
          </div>
          <div className="bg-zinc-900/50 rounded-lg p-6 md:p-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8 content-start">
            {specs.map((spec, i) => <div key={i} data-index={i} className="flex flex-col space-y-1">
                {i !== 6 && <span className="text-zinc-100 font-semibold font-default !text-2xl !w-[450px]">
                  {spec.label}
                </span>}
                <span className="text-zinc-400 !text-xl">
                  {spec.value}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}